/* =========================================================================================
  File Name:
  Description:
  ----------------------------------------------------------------------------------------
  Item Name: GetBoarded UI Template
  Author: GetBoarded
  Author URL: https://www.getboarded.com
========================================================================================== */

import jwt from '../../http/requests/auth/jwt/index.js'
import router from '@/router'

export default {
  // JWT
  loginJWT ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      jwt.login(payload.userDetails.email, payload.userDetails.password)
        .then(response => {

          // If there's user data in response
          if (response) {
            // Navigate User to homepage
            router.push(router.currentRoute.query.to || '/')

            // Set accessToken
            localStorage.setItem('accessToken', response.accessToken)

            // Update user details
            commit('UPDATE_USER_INFO', response.user, {root: true})

            // Set bearer token in axios
            commit('SET_BEARER', response.accessToken)

            resolve(response)
          } else {
            reject({message: 'Wrong Email or Password'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  registerUserJWT ({ commit }, payload) {

    const { id,  username, email, job_title, company, password, status,isVerified } = payload.userDetails

    return new Promise((resolve, reject) => {

      // Check confirm password
      /*if (password !== password) {
        reject({message: 'Password doesn\'t match. Please try again.'})
      }*/

      jwt.registerUser(id, username, email, job_title, company, password, status,isVerified)
        .then(response => {
          // Redirect User
          // router.push(router.currentRoute.query.to || '/add-skill') // redirect to add skill flow
          // Update data in localStorage
          // localStorage.setItem('accessToken', response.data.accessToken)
          // commit('UPDATE_USER_INFO', response.data.userData, {root: true})

          resolve(response)
        })
        .catch(error => { reject(error) })
    })
  },

  fetchAccessToken () {
    return new Promise((resolve) => {
      jwt.refreshToken().then(response => { resolve(response) })
    })
  }
}
